export const UPDATE_CURRENCY = "UPDATE_CURRENCY";
